import { gql } from "@apollo/client";

const SUBMIT_CART = gql`
  mutation SubmitCart(
    $productId: ID!
    $retroactiveDate: Date
    $retroactiveStatus: String
    $requestedByUserId: ID
    $expedite: Boolean
  ) {
    submitCart(
      productId: $productId
      retroactiveDate: $retroactiveDate
      retroactiveStatus: $retroactiveStatus
      requestedByUserId: $requestedByUserId
      expedite: $expedite
    ) {
      ... on GrantTransaction {
        _id
        transactionType
        transactionStatus
        transactionAmount
      }
    }
  }
`;

const CREATE_BRANDED_PRODUCT = gql`
  mutation CreateBrandingProduct($entityId: ID!, $args: CombinedCreateProductInput) {
    createBrandingProduct(entityId: $entityId, args: $args) {
      _id
    }
  }
`;

const CREATE_PRODUCT = gql`
  mutation CreateProduct($userId: ID!) {
    createProduct(userId: $userId) {
      ... on DafProduct {
        _id
      }
    }
  }
`;

export { SUBMIT_CART, CREATE_BRANDED_PRODUCT, CREATE_PRODUCT };
